<div class="executed-header executed-header--{{ type }}">
  <span class="title">
    {{ title }}: aanvraagdatum
    {{ currentCreatedAt | date: 'dd/MM/yyy' }}
    <span *ngIf="showTime" class="normal">
      {{ currentCreatedAt | date: 'HH:mm' }}
    </span>
    <span *ngIf="approved && !!approvedRegistration" class="smaller black ml-3">
      ({{
        approvedRegistration.by?.firstName
          | personName: approvedRegistration.by?.lastName
      }}
      - {{ approvedRegistration.date | date: 'dd/MM/yyy HH:mm' }})
    </span>
  </span>
  <ng-container
    *ngIf="
      type === 'baseproject' || requestContact == null;
      else requestContactRow
    "
  >
    <div class="small-upper-space">
      <div *ngFor="let pcg of projectContactGroups; let first = first">
        <div class="d-flex" [ngClass]="!first ? 'smaller-upper-space' : ''">
          <div
            class="company-name title"
            [class.clickable]="!client"
            [routerLink]="[
              pcg?.company?.id != null
                ? '/bedrijven/' + pcg.company.id
                : '/bedrijven'
            ]"
          >
            <b>{{ pcg.company.regularName }}</b> -
          </div>
          <div>
            <div *ngFor="let contact of pcg.contacts" class="d-flex">
              <span
                >&nbsp;{{
                  contact.firstName | personName: contact.lastName
                }}</span
              >
              <span
                *ngIf="contact.phoneNumberDisplay?.length > 0"
                class="preserve-span-space"
              >
                /
                <ng-container *ngIf="client; else phoneLink">
                  {{ contact.phoneNumberDisplay }}
                </ng-container>
                <ng-template #phoneLink>
                  <a
                    class="click-link"
                    href="tel:{{ contact.phoneNumberDisplay }}"
                    >{{ contact.phoneNumberDisplay }}</a
                  >
                </ng-template>
              </span>
              <span
                *ngIf="contact.mobileNumberDisplay?.length > 0"
                class="preserve-span-space"
              >
                /
                <ng-container *ngIf="client; else phoneLink">
                  {{ contact.mobileNumberDisplay }}
                </ng-container>
                <ng-template #phoneLink>
                  <a
                    class="click-link"
                    href="tel:{{ contact.mobileNumberDisplay }}"
                    >{{ contact.mobileNumberDisplay }}</a
                  >
                </ng-template>
              </span>
              <span
                *ngIf="contact.emailDisplay?.length > 0"
                class="preserve-span-space"
              >
                /
                <ng-container *ngIf="client; else mailLink">
                  {{ contact.emailDisplay }}
                </ng-container>
                <ng-template #mailLink>
                  <a
                    class="click-link"
                    href="{{
                      contact.emailDisplay
                        | mailSubjectBodyLink
                          : projectId
                          : contact.firstName
                          : address?.line1
                          : address?.postalCode
                          : address?.city
                          : ''
                          : 'Job'
                    }}"
                  >
                    {{ contact.emailDisplay }}
                  </a>
                </ng-template>
              </span>
              <div
                *ngIf="!client && contact.emailDisplay?.length > 0"
                class="clickable impersonate-icon"
                [class.disabled]="contact.contactUserId == null"
                [matTooltip]="
                  contact.contactUserId != null
                    ? 'Nabootsen'
                    : 'Nabootsen niet mogelijk, geen gebruiker gevonden'
                "
                (click)="impersonateContact(contact, pcg.company)"
              >
                <mat-icon>group</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="small-upper-space"
        *ngIf="
          showExtraContacts &&
          extraCompanyContacts != null &&
          extraCompanyContacts.length > 0
        "
      >
        <div class="strong mt-3">Bedrijfsnaam - contactpersoon</div>
        <div *ngFor="let extra of extraCompanyContacts; let f = f">
          <div class="w-100">
            {{ extra.company + ' - ' + extra.contact }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #requestContactRow>
    <div class="small-upper-space">
      <div>
        <div class="d-flex">
          <div
            class="company-name title"
            [class.clickable]="!client"
            [routerLink]="[
              requestContact?.company?.id != null
                ? '/bedrijven/' + requestContact.company.id
                : '/bedrijven'
            ]"
          >
            <b>{{ requestContact.company.regularName }}</b> -
          </div>
          <div>
            <div class="d-flex">
              <span
                >&nbsp;{{
                  requestContact.contact.firstName
                    | personName: requestContact.contact.lastName
                }}</span
              >
              <span
                *ngIf="requestContact.contact.phoneNumberDisplay?.length > 0"
                class="preserve-span-space"
              >
                / {{ requestContact.contact.phoneNumberDisplay }}
              </span>
              <span
                *ngIf="requestContact.contact.mobileNumberDisplay?.length > 0"
                class="preserve-span-space"
              >
                / {{ requestContact.contact.mobileNumberDisplay }}
              </span>
              <span
                *ngIf="requestContact.contact.emailDisplay?.length > 0"
                class="preserve-span-space"
              >
                /
                <ng-container *ngIf="client; else mailLink">
                  {{ requestContact.contact.emailDisplay }}
                </ng-container>
                <ng-template #mailLink>
                  <a
                    class="click-link"
                    href="{{
                      requestContact.contact.emailDisplay
                        | mailSubjectBodyLink
                          : projectId
                          : requestContact.contact.firstName
                          : address?.line1
                          : address?.postalCode
                          : address?.city
                          : ''
                          : 'Job'
                    }}"
                  >
                    {{ requestContact.contact.emailDisplay }}
                  </a>
                </ng-template>
              </span>
              <div
                *ngIf="
                  !client &&
                  !placer &&
                  requestContact.contact.emailDisplay?.length > 0
                "
                class="clickable impersonate-icon"
                [class.disabled]="requestContact.contactUserId == null"
                [matTooltip]="
                  requestContact.contactUserId != null
                    ? 'Nabootsen'
                    : 'Nabootsen niet mogelijk, geen gebruiker gevonden'
                "
                (click)="
                  impersonateProjectContact(
                    requestContact,
                    requestContact.company
                  )
                "
              >
                <mat-icon>group</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
